<template>
    <div class="jobOffers app">
        <swiperBanner :bannerList='bannerList'></swiperBanner>
        <div class="main-content">
            <div class="job-search clearfix">
                <div class="fr clearfix form-box">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="职位">
                            <el-input  @keyup.enter.native="onSubmit($event)" v-model="formInline.post" placeholder="请输入关键词" @blur="formInline.post = changeValue($event)"></el-input>
                        </el-form-item>
                        <el-form-item label="工作地点">
                            <el-select v-model="formInline.workplace_id" placeholder="请选择">
                                <el-option v-for="item in workplaceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="专业科室">
                            <el-select v-model="formInline.department_id" placeholder="请选择">
                                <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit" class="searchBtn">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="job-ul">
                <div class="job-li hand-shape" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.id)">
                    <div class="job-detail">
                        <div class="title fs18 fwb color-blank">{{item.post}}</div>
                        <div class="detail pt10">
                            <span v-if="item.type==1">{{item.group_name}}</span>
                            <span v-else>{{item.hospital_name}}</span>
                        | {{item.workplace}} | {{item.department}} | {{item.num}}
                        <span v-for="(key,index) in item.key" :key="index">| {{key}}</span> 
                        </div>
                    </div>
                    <div class="scan-more color-blue">查看详情<img src="../../assets/images/arrow-right.png" alt="" class="arrow-icon"></div>
                </div>
            </div>
            <el-col  :span="24" class="toolbar">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="alltotal">
                </el-pagination>
                <nav-top></nav-top>
            </el-col>
        </div>
    </div>
</template>
<script>
import swiperBanner from '@/components/swiperBanner'
import navTop from '@/components/top'
import seoArgs from '../../utils/setSeoArgs';

export default {
    data() {
        return {
            bannerList:[],
            dataList:[],
            page:1,
            pageSize:10,
            alltotal:0,
            formInline: {
                post: '',
                workplace_id: '',  
                department_id:'', 
            },
            workplaceList: [],
            departmentList:[]
        };
    },
    created() {
        const doctorSeoInfo = this.$cookies.get(this.api.cachePrex+'Recruit') || {};
        doctorSeoInfo.name = '招贤纳士';
        seoArgs.setSeoArgs(doctorSeoInfo);

        this.getBanner();
        this.getWorkplaces();
        this.getDepartments();
        this.getRecruit(1);
    },
    mounted() {

    },
    methods: {
        onSubmit(e) {
            if(e.target.value){
             this.formInline.post=e.target.value;
            }
            this.getRecruit(1);
        },
        getBanner(){
            this.$axios.post(this.api.index.banners,{item:'Recruit'},res =>{
                this.bannerList=res.data;
            },err =>{
                this.bannerList=[];
            });
        },
        getWorkplaces(){
            this.$axios.post(this.api.recruit.workplaces,{},res =>{
                let listdata=res.data;
                let cardlistarr=[{
                    id:null,
                    name:'全部'
                }]
                this.workplaceList=cardlistarr.concat(listdata);
            },res =>{
                this.workplaceList=[];
            });
        },
        getDepartments(){
            this.$axios.post(this.api.recruit.departments,{},res =>{
                let listdata=res.data;
                let cardlistarr=[{
                    id:null,
                    name:'全部'
                }]
                this.departmentList=cardlistarr.concat(listdata);
            },res =>{
                this.departmentList=[];
            });
        },
        getRecruit(pageIndex){
            if(pageIndex){this.page=1}
            this.$axios.post(this.api.recruit.list,{
                post:this.formInline.post,
                workplace_id:this.formInline.workplace_id,
                department_id:this.formInline.department_id,
                page:this.page,
                page_size:this.pageSize
            },res =>{
                this.dataList=res.data;
                for(var i in this.dataList){
                        var keyword_ids=[];
                        var item=this.dataList[i];
                        if(item.keyword){
                            item.keyword=item.keyword.replace(/，/ig,',');
                            if(item.keyword.indexOf(",") == -1){
                                keyword_ids.push(item.keyword);
                            }
                            else{
                                var strs=item.keyword.split(","); //字符分割
                                keyword_ids=strs;
                            }
                        }
                        this.$set(this.dataList[i], 'key', keyword_ids)
                }
                this.alltotal=Number(res.pageInfo.totalCount);
            },err =>{
                this.dataList=[];
                this.alltotal=0;
            });
        },
        //页面改变
        handleCurrentChange(val) {
            this.page=val;
            this.getRecruit();
        },
        //每页的页数改变
        handleSizeChange(val) {
            this.pageSize=val;
            this.getRecruit();
        },
        goDetail:function(id){
            this.$router.push('/recruitDetail/'+id+'.html');
        },
    },
    components: {
        swiperBanner,
        navTop
    },
};
</script>
<style scoped>
    .job-ul{margin-top:20px;}
    .job-li{background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;position: relative;margin-bottom:20px;}
    .job-li:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
    .job-detail{padding:30px 20px;}
    .job-detail .title{line-height:25px;}
    .job-detail .detail{color:#666;line-height: 20px;}
    .job-li .scan-more{position: absolute;top:50%;right:20px;height:20px;line-height:20px;margin-top:-10px;}
</style>
<style>
.job-search  .el-form-item__content,.job-search .el-input__icon{line-height:28px;}
.job-search .el-form-item__label{color:#666;font-size:14px;line-height:28px;}
.job-search .el-input__inner{width:160px;height:28px;line-height:28px;padding-left:10px;font-size:14px;background:#fff;border-radius:5px;border:1px solid rgba(217,217,217,1)}
.job-search .el-button.searchBtn{padding:0;height:28px;width:60px;border-radius:5px;}
</style>


// WEBPACK FOOTER //
// src/view/recruit/index.vue